"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontFaceCss = void 0;
const types_1 = require("../../types");
const misc_1 = require("./misc");
/**
 * @param usedFont A font used in the epub
 * @param isPreviewer whether the css are for previewer
 * @returns @font-face css for the selected font variant
 */
const getFontFaceCss = (usedFont, isPreviewer) => {
    const { id, variant, remoteSrc, localSrc } = usedFont;
    let cssString = "\n";
    const fontFamilyName = (0, misc_1.getFontFamilyName)(id, variant);
    /** "fonts/fontName.extension" is the default fonts folder location for bundled epubs */
    const fontSrc = isPreviewer ? remoteSrc : `${misc_1.epubFontBaseUrl}/${localSrc}`;
    cssString += `@font-face{\n  font-family: ${fontFamilyName};\n  src: url("${fontSrc}");\n  `;
    if (variant === types_1.FontVariant.bold)
        cssString += "font-weight: bold;  ";
    if (variant === types_1.FontVariant.italic)
        cssString += "font-style: italic;  ";
    if (variant === types_1.FontVariant.boldItalic)
        cssString += "font-weight: bold;\n  font-style: italic;  ";
    if ([
        types_1.FontVariant.weight_100,
        types_1.FontVariant.weight_200,
        types_1.FontVariant.weight_300,
        types_1.FontVariant.weight_500,
        types_1.FontVariant.weight_600,
        types_1.FontVariant.weight_700,
        types_1.FontVariant.weight_800,
        types_1.FontVariant.weight_900,
    ].includes(variant)) {
        cssString += `font-weight: ${variant};  `;
    }
    if ([
        types_1.FontVariant.italic_100,
        types_1.FontVariant.italic_200,
        types_1.FontVariant.italic_300,
        types_1.FontVariant.italic_500,
        types_1.FontVariant.italic_600,
        types_1.FontVariant.italic_700,
        types_1.FontVariant.italic_800,
        types_1.FontVariant.italic_900,
    ].includes(variant)) {
        cssString += `font-weight: ${(0, misc_1.getNumericPartFromVariant)(variant)};\n  font-style: italic;  `;
    }
    cssString += `\n}\n.${fontFamilyName}{\n  font-family: ${fontFamilyName};\n}`;
    return cssString;
};
exports.getFontFaceCss = getFontFaceCss;
